import "./Recharge.css";
import "./index.css";
import React, { useEffect, useState } from "react";
import "./Global.js";
import { useConfigs } from "./components/ConfigsContext";
import useAppImages from "./components/AppImages";

const strapiServerUrl = window.strapiServerUrl;

export default function Recharge() {
  const [attributesData, setAttributesData] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [RechargeTypes, setRechargeTypes] = useState([]);
  const [filteredBundles, setFilteredBundles] = useState([]);
  const [bundleTypeIndex, setBundleTypeIndex] = useState(null); //for setting different colored cards for even and odd menu
  const { loading, error, data } = useConfigs();
  const [iconData, setIconData] = useState({});
  // eslint-disable-next-line
  const [appImages, sectionDesc] = useAppImages();
  const [rechargeImage, setRechargeImage] = useState(null);

  //To set Scrollbar only visible when its overflowing
  useEffect(() => {
    if (filteredBundles) {
      const rechargeCardsItems = document.querySelector(
        ".recharge_cards--items"
      );
      if (rechargeCardsItems) {
        if (rechargeCardsItems.scrollWidth > rechargeCardsItems.clientWidth) {
          rechargeCardsItems.classList.add("overflowing");
        } else {
          rechargeCardsItems.classList.remove("overflowing");
        }
      }
    }
  }, [filteredBundles]);

  const handleTypeSelect = (type, index) => {
    setSelectedType(type);
    setBundleTypeIndex(index + 1);
    const filteredBundles = attributesData?.filter(
      (item) => item.attributes.config_name === type
    );
    setFilteredBundles(filteredBundles);
  };

  const updateAttributesData = (bundles, appIcons) => {
    if (bundles && appIcons) {
      const iconMap = {};
      appIcons.forEach((icon) => {
        iconMap[icon.attributes.icon_code] = {
          value: icon.attributes.icon_name,
          icon: icon.attributes.icon_image.data.attributes.url,
        };
      });
      setIconData(iconMap);
      setAttributesData(bundles);
      //Extracting Types
      const RechargeTypes = [];
      bundles.forEach((config) => {
        const RechargeType = config.attributes.config_name;
        if (!RechargeTypes.includes(RechargeType)) {
          RechargeTypes.push(RechargeType);
        }
      });
      setRechargeTypes(RechargeTypes);
      setSelectedType(RechargeTypes[0]);
      setBundleTypeIndex(1);

      //Initial Filtering of Bundles
      const filteredBundles = bundles?.filter(
        (item) => item.attributes.config_name === RechargeTypes[0]
      );
      setFilteredBundles(filteredBundles);
    }
  };

  useEffect(() => {
    if (data) {
      const rechangeBundles = data.configs.data;
      const appIcons = data.appIcons.data;
      updateAttributesData(rechangeBundles, appIcons);
    }
  }, [data]);

  useEffect(() => {
    if (appImages) {
      setRechargeImage(appImages["recharge"]);
    }
  }, [appImages]);

  return (
    <div className="recharge_main--container">
      <section className="recharge_section">
        <div className="recharge_banner">
          <div className="recharge_banner_image">
            {rechargeImage && (
              <img src={`${strapiServerUrl}${rechargeImage}`} alt="" />
            )}
          </div>
        </div>
        <div className="recharge_cards">
          <div>
            <ul className="recharge_cards--menu">
              {RechargeTypes &&
                RechargeTypes.map((type, index) => (
                  <li key={type}>
                    <div
                      className={`recharge_menu-link  ${
                        selectedType === type ? "selected" : ""
                      }`}
                      style={{
                        cursor: selectedType !== type ? "pointer" : "default",
                      }}
                      onClick={() =>
                        selectedType !== type &&
                        RechargeTypes.length > 1 &&
                        handleTypeSelect(type, index)
                      }
                    >
                      {type}
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <div className="recharge_cards--items">
            {loading ? (
              <div>Loading...</div>
            ) : error ? (
              <div>Error: {error.message}</div>
            ) : (
              filteredBundles &&
              filteredBundles.map((item, index) => (
                <div className="recharge_cards--item" key={index}>
                  <div className="recharge_cards--item-inner">
                    <div
                      className="recharge_cards--item-front"
                      data-bundle-price={item.attributes.card_front.currency}
                      style={
                        bundleTypeIndex % 2 === 0
                          ? { backgroundColor: "#575F78" }
                          : { backgroundColor: "#dc2941" }
                      }
                    >
                      <div className="recharge_cards--item-front-content">
                        <h2>{item.attributes.card_front.value}</h2>
                      </div>
                    </div>
                    <div className="recharge_cards--item-back">
                      <div className="recharge_cards--item-content">
                        <div className="rch_section">
                          <div className="rch_icon">
                            <img
                              src={`${strapiServerUrl}${item.attributes.category_icon.data.attributes.url}`}
                              alt="icon"
                            />
                          </div>
                          <div className="rch_pack">
                            <h3>{item.attributes.config_category}</h3>
                            <h3 className="clr_grey">{item.attributes.type}</h3>
                          </div>
                        </div>
                        {Object.entries(item.attributes.card_back).map(
                          ([key, value]) => (
                            <div className="rch_section" key={key}>
                              <div className="rch_icon">
                                <img
                                  src={`${strapiServerUrl}${iconData[key].icon}`}
                                  alt={iconData[key].value}
                                />
                              </div>
                              <div className="rch_pack">
                                <h3 className="sub_text">{value}</h3>
                                {/*iconData[key].value && <h3 className="clr_grey">{iconData[key].value}</h3>*/}
                              </div>
                            </div>
                          )
                        )}
                        <a
                          href="https://recharge.rennamobile.com/"
                          className="rch_button">
                          Recharge
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
